import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/smart-lead.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Smart Lead Capture & Conversion</h3>
                            <p>Converzex.ai  intelligently captures and qualifies leads through real-time AI conversations, helping businesses focus on customers with genuine buying intent. Our Chat Agent and voice agents collect key details such as customer requirements, budget, location preferences, and contact information while automatically identifying high-intent prospects.</p>
                            <p>Once qualified, leads are instantly routed to your dashboard or CRM, allowing your sales team to respond faster and close opportunities more efficiently. By automating the lead generation process and reducing manual follow-ups, Converzex.ai helps increase conversion rates, improve response time, and maximize business growth.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                
            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails